import * as React from "react";

export const HighlightGrowContext = React.createContext<GrowCallback>(() => undefined);

type GrowCallback = (grow: GrowType) => void;
export type GrowType = "never" | "always" | "last";
export type DateTimeVariant = "date" | "date-time";
